export default __webpack_public_path__ + "static/media/scroll.07d01480.png";